import React, {PureComponent} from "react"
import {connect} from "@irati/store"
import {FormattedMessage} from "@irati/utils/lang"

import {StepWrapper, StepsRecap, Steps, ActiveBar, Step} from "./styled"

interface Props {
  currentStep: number,
  stepsCount: number,
  className: string,
  isMobile: boolean
}

interface ReduxProps {
  mq: {
    lessThan: {
      sm: boolean
    }
  }
}

class StepIndicator extends PureComponent<Props> {
  render() {
    const {currentStep, isMobile, stepsCount, className} = this.props
    const steps = []
    for (let i = 1; i <= stepsCount; i++) steps.push(i)

    return (
      <StepWrapper isMobile={isMobile} className={className}>
        <StepsRecap>
          <FormattedMessage
            id="platform.stepIndicator.stepsCounter"
            values={{
              currentStep: (
                <strong>
                  <FormattedMessage id="platform.stepIndicator.currentStep" values={{currentStep}} />
                </strong>
              ),
              totalSteps: steps.length
            }} />
        </StepsRecap>
        <Steps>
          <ActiveBar active={currentStep} />
          {steps.map((step, i) => (
            <Step active={i + 1 <= currentStep} key={i}>
              {step}
            </Step>
          ))}
        </Steps>
      </StepWrapper>
    )
  }
}

const mapStateToProps = ({mq}: ReduxProps) => ({isMobile: mq.lessThan.sm})

export default connect(mapStateToProps)(StepIndicator)
